<div class="container">

  <h2>Thank You</h2>
  <p>Thank you, once your membership is processed a client manager will reach out to you with next steps.</p>
</div>
